module.exports = __webpack_public_path__ + "static/img/Bachelor_010786.9f01b12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010786.jpg
// module id = 246
// module chunks = 0